import { getDetectLiveClustering3 } from "./../api/detect";
import { useQuery } from "@tanstack/react-query";
import { useLocation } from "react-router-dom";
import { GetDetectLiveClustering3Params } from "../types/types";
import userStorage from "../utils/userStorage";

const useGetDetectLiveClustering3 = ({
  area,
  mobility_code = -1,
  searchKey = "",
  eps,
  level,
  minPts,
  swlng,
  swlat,
  nelng,
  nelat,
  startDate,
  endDate,
  event_code,
  groupId,
}: GetDetectLiveClustering3Params) => {
  const location = useLocation();
  const user = userStorage.get();

  const { data, isSuccess, isLoading, isError } = useQuery({
    queryKey: [
      "DetectLiveClustering3",
      `mobility_code-${mobility_code}`,
      `searchKey-${searchKey}`,
      `area-${area}`,
      `eps-${eps}`,
      `swlng: ${swlng}`,
      `swlat: ${swlat}`,
      `nelng: ${nelng}`,
      `nelat: ${nelat}`,
      `startDate: ${startDate}`,
      `endDate: ${endDate}`,
      `event_code: ${event_code}`,
      `groupId: ${groupId}`,
    ],
    queryFn: () =>
      getDetectLiveClustering3({
        mobility_code,
        searchKey,
        area,
        eps,
        level,
        minPts,
        swlng,
        swlat,
        nelng,
        nelat,
        startDate,
        endDate,
        event_code,
        groupId,
      }),
    retry: false,
    enabled:
      location.pathname !== `/login` &&
      location.pathname !== `/maintenance` &&
      !!user,
    staleTime: 0,
  });

  return { data, isSuccess, isLoading, isError };
};

export default useGetDetectLiveClustering3;
